google.charts.load('current', {'packages': ['geochart'], 'mapsApiKey': process.env.MIX_SERVICES_GOOGLE_GEOCHART_API_KEY});

google.charts.setOnLoadCallback(drawMarkersMap);
google.charts.setOnLoadCallback(drawRegionsMap);

function drawMarkersMap() {
	var data = google.visualization.arrayToDataTable([['City'], ['Thessaloniki'], ['Athens']]);

	var options = {
		displayMode: 'markers',
		region: 'GR',
		defaultColor: '#E67728',
		datalessRegionColor: '#FFFFFF',
		backgroundColor: {fill: '#0D5EAF', stroke: '#281B6C', strokeWidth: 1},
		keepAspectRatio: false
	};

	var chart = new google.visualization.GeoChart(document.getElementById('geocharts-greece'));

	chart.draw(data, options);
};

function drawRegionsMap() {
	var data = google.visualization.arrayToDataTable([['Country'], ['Greece'], ['Germany'], ['Austria'], ['Bulgaria'], ['Romania'], ['Ukraine'], ['Latvia'], ['Lithuania'], ['Estonia'], ['Serbia'], ['Montenegro'], ['Slovenia']]);

	var options = {
		displayMode: 'regions',
		region: '150',
		defaultColor: '#E67728',
		datalessRegionColor: '#FFFFFF',
		backgroundColor: {fill: '#0D5EAF', stroke: '#281B6C', strokeWidth: 1},
		keepAspectRatio: false
	};

	var chart = new google.visualization.GeoChart(document.getElementById('geocharts-world'));

	chart.draw(data, options);
}
